module.exports = __webpack_public_path__ + "static/media/icon-support.d29e13b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/icon-support.svg
// module id = 1557
// module chunks = 1